import AdyenDropInCheckout from 'components/payments/AdyenDropInCheckout';
import PlainLoadingSpinner from 'components/PlainLoadingSpinner';
import { useEffect, useState } from 'react';
import { Message } from 'semantic-ui-react';
import { scrollToSection, sleep } from 'utils/common';
import { TPurchaseTokensResponse } from '.';
import { SOURCE_QUERY_PARAM } from '../../../pages/validate-3ds-payment';

interface IPaymentForm {
  tokenOrder: TPurchaseTokensResponse | null;
  completionHandler: () => void;
  customRedirectFor3DS?: any;
}

const PaymentForm = ({
  tokenOrder,
  completionHandler,
  customRedirectFor3DS,
}: IPaymentForm) => {
  const [loading, setLoading] = useState(!tokenOrder?.adyenPaymentSession);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (loading && tokenOrder?.adyenPaymentSession) {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenOrder?.adyenPaymentSession]);

  return (
    <div className="tokenPurchasePaymentForm">
      {error && <Message negative>{error}</Message>}

      {tokenOrder?.adyenPaymentSession && !loading ? (
        <AdyenDropInCheckout
          queryParamsObject={{
            source: `${SOURCE_QUERY_PARAM.TOKENS}${customRedirectFor3DS ? `:${customRedirectFor3DS}` : ''}`,
          }}
          initialRedirectResult={null}
          paymentSession={tokenOrder.adyenPaymentSession}
          onLoadingStateChange={(loading) => {
            setLoading(loading);
          }}
          completionHandler={async () => {
            await completionHandler();
          }}
          displayError={async (err) => {
            setError(err);
            if (!err) return;
            // Scroll to error
            await sleep(200); // Needed, otherwise form doesn't display (after cancelled payment), and to prevent `APP-X` sentry issue.
            scrollToSection('#errorMessage');
          }}
        />
      ) : (
        <PlainLoadingSpinner style={{ margin: '5em auto' }} />
      )}
    </div>
  );
};

export default PaymentForm;
